export const PLANNING_SETTINGS_COPY = {
  tabsLabel: "Planning settings",
  title: "Planning",
  generalTab: "General",
  agentTab: "Agent",
  automationTab: "Automation",
  planningLabel: "Planning",
  planningHelper: "An agent starts a planning session for each task that enters Backlog, to raise the success rate.",
  checksLabel: "Planning checks",
  checksHelper: "What the agent checks in each planning session.",
  checksOffHelper: "Turn Planning on to use these checks.",
  confidenceLabel: "Confidence estimate",
  confidenceHelper: "The agent checks if one run can finish the task and offers to split work that is too big.",
  clarityLabel: "Clarity check",
  clarityHelper: "The agent grades how clear the request is and keeps asking until the gaps are closed.",
  autoStartLabel: "Auto-start",
  autoStartHelper: "Auto-start tasks that have scored 5/5.",
  autoStartPlanningOffHelper: "Turn Planning on to use Auto-start.",
  autoStartConfidenceOffHelper: "Turn the Confidence estimate on to use Auto-start.",
  autoStartNoBoardHelper: "Set up a board before you turn Auto-start on.",
  autoStartStartOnLabel: "Start on",
  healthLabel: "Health",
  healthReady: "Ready",
  healthDisabled: "Off",
  healthReadyHelper: "An agent plans each task that enters Backlog.",
  healthDisabledHelper: "Tasks wait in Backlog as written. Nobody plans them.",
  save: "Save",
  saving: "Saving",
  saveError: "Could not save Planning settings.",
  loading: "Loading Planning settings.",
  loadError: "Could not load Planning settings.",
  retry: "Retry",
  automationEmpty: "This automation has no steps yet.",
  automationLoading: "Loading the steps.",
  automationError: "Could not load the steps.",
} as const;
